export default __webpack_public_path__ + "static/media/macos.0e548e83.svg";